import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { BaseUiModule } from '@mitsubishi/shared/ui';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'apm-invalid-link-page',
  imports: [CommonModule, BaseUiModule, RouterLink, FaIconComponent],
  templateUrl: './invalid-link-page.component.html',
  styleUrl: './invalid-link-page.component.scss',
})
export class InvalidLinkPageComponent {}
